"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _purpleCheck = _interopRequireDefault(require("../assets/svg/purple-check.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var CheckMark = function CheckMark(_ref) {
  var children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "my-3 text-center" : _ref$className;
  return /*#__PURE__*/_react["default"].createElement("p", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: _purpleCheck["default"],
    alt: "",
    className: "inline pr-3"
  }), children);
};
var _default = exports["default"] = CheckMark;